module.exports = __webpack_public_path__ + "static/media/oz-splash1.312a8da9.jpg";